module.exports = __webpack_public_path__ + "static/img/footer_img_wechat_dl.34acd57.png";


//////////////////
// WEBPACK FOOTER
// ./static/pc/footer_img_wechat_dl.png
// module id = 6Gdt
// module chunks = 0